export default __webpack_public_path__ + "static/media/icone-play.3f4597f8.svg";